<div #step3 class="ui-g">

  <div class="ui-g-12">

    <p-messages [(value)]="errors"></p-messages>
    <p-messages [(value)]="warnings"></p-messages>

    <div class="card left budget">

      <div class="ui-g form-group">
        <div class="ui-g-12">
          <div class="ui-g-4">
            <div class="subtitle">
              <div class="campaign-sub">{{ 'campaign.budgetAmount' | translate }} (€)</div>
            </div>
            <span class="budget-search">
              <p-spinner placeholder="0" [thousandSeparator]="'.'" [min]="0" [step]="1000" size="30" [(ngModel)]="campaign.budget" (onChange)="updateBudget()"></p-spinner>
            </span>
          </div>
        </div>

        <div class="ui-g-12">
          <div class="ui-g-12 ui-md-4" *ngFor="let budget of budgets; let i = index;">

            <label>{{ budget.name }} (%)</label>
            <p-spinner
            [min]="budget.min" [max]="budget.max"
            [(ngModel)]="budget.value"
            (focusout)="updateSlider($event)"
            [name]="budget.name"
            limitInputNum>
            </p-spinner>

          </div>
        </div>

        <div class="ui-g-12">
            <app-triple-percentage-slider (percentagesChanged)="percentagesHandler($event)"></app-triple-percentage-slider>
          <div class="ui-g-12">
            <label>{{ 'campaign.budgetNotes' | translate }}</label>
          </div>
          <textarea pInputTextarea rows="10" class="notes-input" cols="60" [(ngModel)]="campaign.notes"></textarea>
        </div>

      </div>

    </div>
  </div>

</div>



// WEBPACK FOOTER //
// ./src/app/views/campaign/new-campaign/step-3/campaign-step-3.html